<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_7"></a><a id="ch3"></a><em>Window: Thing as Participle</em></h3>
<p class="noindent">Welling and flowing and fastening, too,</p>
<p class="noindent">the window itself became the fever,</p>
<p class="noindent">faces waved and surfed</p>
<p class="noindent">across its surface . . .</p>
<p class="noindentt">Stop that, she rebuked herself,</p>
<p class="noindent">people are only passing on the sidewalk,</p>
<p class="noindent">people are simply walking on the sidepass, yes,</p>
<p class="noindent">that’s all you’re seeing, so much</p>
<p class="noindentt">water in an eye. But then the sneezes rose</p>
<p class="noindent">from somewhere to attack</p>
<p class="noindent">whole buildings, schools and churches,</p>
<p class="noindent">massive stoneworks, city hall—</p>
<p class="noindent">whatever stood, stood to be wracked—</p>
<p class="noindent">did no one notice? They were all</p>
<p class="noindent">at risk: whatever the window held</p>
<p class="noindent">could tremble. Mortified, she sat</p>
<p class="noindentt">in the eye of the storm, with steam</p>
<p class="noindent">from cups of cure to drape</p>
<p class="noindent">or dramatize her time away; but still</p>
<p class="noindent">the window went on streaming</p>
<p class="noindent">all these bundled half-lives by, in one</p>
<p class="noindent">continuous unravelling of differences, of</p>
<p class="noindent">higher, lower, lighter, darker,</p>
<p class="noindent">faces framed in fur or bared of head,</p>
<p class="noindent">blown blond or blasted black, each one appointed</p>
<p class="noindent">in a halo’s freeze-burn or an aura’s sun-chill,</p>
<p class="noindent">each one with its hunch of forehead, over</p>
<p class="noindent">only two hot coals per person . . .</p>
<p class="noindentt">Humankind was understandable in this</p>
<p class="noindent">unending sentence of an <span class="small">EEG</span> she witnessed</p>
<p class="noindent">scrolling by; it was, at each new moment, modelled</p>
<p class="noindent">into spikes of single-mindedness; but every</p>
<p class="noindent">bobbing of discreteness in the flow, each</p>
<p class="noindent">block or chunk, each head, she knew</p>
<p class="noindent">(she knew) had its</p>
<p class="noindent"><a id="page_8"></a>own helixing and coils</p>
<p class="noindent">of orienting endlessness, its moving</p>
<p class="noindent">windows of reflective flux,</p>
<p class="noindent">and its own someone</p>
<p class="noindent">in a fix: that figure</p>
<p class="noindent">underlying everything, that glimpse</p>
<p class="noindentt">in brown or blue, with fringe of lash:</p>
<p class="noindent">a holy icon, prize of self, an image</p>
<p class="noindent">irrecoverably, shimmeringly</p>
<p class="noindent">still, it is so deeply</p>
<p class="noindentt">plunged into the nominative . . .</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?68e8ef90